module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/mdbreact/~/isarray/index.js
// module id = 405
// module chunks = 0